import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image, Card, Button } from "react-bootstrap";
import EngagementModal from "./EngagementModal";
import EngagementSetup from './EngagementSetup/EngagementSetup';
import Loader from "../../components/Loader";
import IconProgress from "../../images/logo-lg.png";
import emptyStateImage from "../../images/dashboard/empty-state.png";
import EngagementTable from "./EngagementTable";
import OverviewDataCards from './OverviewDataCards';
import TotalIcon from "../../images/dashboard/icon-total.png";
import CompleteIcon from "../../images/dashboard/icon-completed.png";
import AuditIcon from "../../images/dashboard/icon-audits.png";
import ReviewIcon from "../../images/dashboard/icon-reviews.png";
import AddClientModal from "./AddClientModal";
import iconAdd from "../../images/Icons-add.png";
import axios from "axios";
import './index.scss';
import { Link, useNavigate, useLocation } from "react-router-dom";
import apiConfig from "../credentials/apiConfig";

function Dashboard() {
  const [loading, setLoading] = useState(true);
  const [engagementData, setEngagementData] = useState([]);
  const [clients, setClients] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showEngagementModal, setShowEngagementModal] = useState(false);
  const navigate = useNavigate();
  const [counts, setCounts] = useState({
    totalEngagements: 0,
    auditEngagements: 0,
    reviewEngagements: 0,
    closedEngagements: 0
  });
  const [isChecked, setIsChecked] = useState(false);
  const [showSetupUI, setShowSetupUI] = useState(false);
  const [selectedEngagementId, setSelectedEngagementId] = useState(null);
  const [dataLoaded, setDataLoaded] = useState({
    clients: false,
    engagements: false
  });

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const authToken = localStorage.getItem("authToken");
        const response = await axios.get(
          `${apiConfig.apiBaseURL}/getAllClients`,
          {
            headers: {
              "x-api-key": apiConfig["x-api-key"],
              "Authorization": `Bearer ${authToken}`
            }
          }
        );

        if (response.data && response.data.success) {
          setClients(response.data.clients);
        } else {
          setClients([]);
        }
      } catch (error) {
        console.error("Error fetching clients:", error);
        setClients([]);
      } finally {
        setDataLoaded(prev => ({ ...prev, clients: true }));
      }
    };
    fetchClients();
  }, [isModalOpen]);
  
  useEffect(() => {
    const authToken = localStorage.getItem("authToken");
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${apiConfig.apiBaseURL}/allEngagementsClientsList`,
          {
            page: 1,
            perPage: 10,
            searchString: '',
            sorting: {},
            filters: {
              industry: [],
              status: [],
              engagementYear: [],
            },
          },
          {
            headers: {
              "x-api-key": apiConfig["x-api-key"],
              "Authorization": `Bearer ${authToken}`,
              "Content-Type": "application/json",
            },
          }
        );


        let engagements = [];
        if (response.data && response.data.success) {
          engagements = response.data.clients[0]?.engagements || [];
          setEngagementData(engagements);
        }


      } catch (error) {
        console.error("Error fetching engagements:", error);
      } finally {
        setDataLoaded(prev => ({ ...prev, engagements: true }));
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (dataLoaded.clients && dataLoaded.engagements) {
      setLoading(false);
    }
  }, [dataLoaded]);

  const handleEditClick = (engagementId) => {
    setSelectedEngagementId(engagementId);
    setShowSetupUI(true);
    navigate(`/engagements/edit-engagement-setup/${engagementId}`, { state: { engagementId: engagementId } });
  }

  const handleAction = () => {
    setIsModalOpen(true);
  };
  const handleEngagementOpen = () => {
    setShowEngagementModal(true);
  };
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
  const handleToggle = (value) => {
    setIsChecked(value);
  };

  const overviewDetails = [
    { label: "Total Engagements", value: counts.totalEngagements, icon: TotalIcon },
    { label: "Closed", value: counts.closedEngagements, icon: CompleteIcon },
    { label: "Audits", value: counts.auditEngagements, icon: AuditIcon },
    { label: "Reviews", value: counts.reviewEngagements, icon: ReviewIcon },
  ];

  const handleShowModal = () => setShowEngagementModal(true);
  const handleCloseModal = () => setShowEngagementModal(false);

  return (
    <>
      {showSetupUI ? (
        <EngagementSetup
          onBack={() => setShowSetupUI(false)}
          engagementId={selectedEngagementId}

        />
      ) : loading ? (
        <Loader />
      ) : (
        <>
          {clients.length !== 0 && (
            <Card className="px-2 py-4" style={{ border: '2px solid #ECEEF5' }}>
              <Row className="all-engagements">
                <Col lg={4} md={12} className="my-auto ">
                  <h3 className="fw-bold mb-0" style={{ fontSize: '20px' }}>Your Engagements</h3>
                </Col>
                <Col lg={8} md={12} className="mt-3 mt-lg-0 engagements-btns">
                  <Row >
                    <Col className="d-flex justify-content-end">
                      <Button variant="outline-primary" size="md" className="px-5 fw-bold me-3" onClick={handleShowModal}>Create New Engagement</Button>
                      <Button variant="primary" size="md" className="px-5 fw-bold" onClick={handleAction} ><img src={iconAdd} alt="add" className="me-2 my-auto" />Add New Client</Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Card>
          )}

          <Container fluid className="my-4 engagement-dashboard">
            <OverviewDataCards overviewDetails={overviewDetails} />

            {clients.length === 0 ? (
              <Row className="justify-content-center text-center my-3">
                <Col md={12}>
                  <Card className="shadow-lg border-0 py-5">
                    <Card.Body className="d-flex flex-column align-items-center">
                      <Image src={emptyStateImage} alt="No Data" className="img-fluid" />
                      <div style={{ backgroundColor: '#F6F6FB' }} className="mt-4 p-5">
                        <Card.Title className="text-dark fw-bold my-3">Dashboard</Card.Title>
                        <p className="text-light" style={{ fontSize: '18px' }}>No metrics or data available on the dashboard—try adding new.</p>
                        <Button variant="primary"
                          className="mt-4 border-0 text-white font-16 px-5 py-3" onClick={handleAction}>
                          Add New Client
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            ) : clients.length > 0 && engagementData.length === 0 ? (
              <Row className="justify-content-center text-center my-3">
                <Col md={12}>
                  <Card className="shadow-lg border-0 py-5">
                    <Card.Body className="d-flex flex-column align-items-center">
                      <Image src={emptyStateImage} alt="No Data" className="img-fluid" />
                      <div style={{ backgroundColor: '#F6F6FB' }} className="mt-4 p-5">
                        <Card.Title className="text-dark fw-bold my-3">Dashboard</Card.Title>
                        <p className="text-light" style={{ fontSize: '18px' }}>No metrics or data available on the dashboard—try adding new.</p>
                        <Button
                          className="me-3  font-16 px-5 py-3" onClick={handleAction} variant="outline-primary">
                          Add New Client
                        </Button>
                        <Button variant="primary"
                          className="border-0 text-white font-16 px-5 py-3" onClick={handleEngagementOpen}>
                          Add New Engagement
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            ) :
              (<Row className="mt-3">
                <Col>
                  <EngagementTable isClientModalOpen={isModalOpen} isEngagementModalOpen={showEngagementModal} setCounts={setCounts} isChecked={isChecked} onEditClick={handleEditClick} />
                </Col>
              </Row>
              )}

            <AddClientModal isOpen={isModalOpen} toggle={toggleModal} onToggle={handleToggle} />

            <EngagementModal
              show={showEngagementModal}
              handleClose={handleCloseModal}
              onToggle={handleToggle}

            />
          </Container>
        </>
      )}
    </>
  );
}

export default Dashboard;